module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Router#1-0b7620ddb0f515c97d197ee9dd46baf8.svg";